import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SingleDatePicker } from 'react-dates';

// Import default styles
import 'react-dates/lib/css/_datepicker.css';

class DatePicker extends Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onChange: PropTypes.func,
  };

  state = {
    focused: false,
  };

  render() {
    const { value, onChange } = this.props;

    return (
      <div className="date-time-picker">
        <SingleDatePicker
          id="date_input"
          date={value || null}
          onDateChange={onChange}
          reopenPickerOnClearDate
          focused={this.state.focused}
          onFocusChange={({ focused }) => {
            this.setState({ focused });
          }}
          showClearDate={false}
        />
      </div>
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/common/components/DatePicker.js